var map = {
	"./arabia.json": "./src/data/arabia.json",
	"./cabbagetown.json": "./src/data/cabbagetown.json",
	"./candler-park.json": "./src/data/candler-park.json",
	"./cascade-springs-nature-preserve.json": "./src/data/cascade-springs-nature-preserve.json",
	"./centennial.json": "./src/data/centennial.json",
	"./central-park.json": "./src/data/central-park.json",
	"./cheshire-farm-trail.json": "./src/data/cheshire-farm-trail.json",
	"./cleopas-johnson.json": "./src/data/cleopas-johnson.json",
	"./constitution-lakes.json": "./src/data/constitution-lakes.json",
	"./couch-park.json": "./src/data/couch-park.json",
	"./esther-peachey-lefevre.json": "./src/data/esther-peachey-lefevre.json",
	"./freedom-park.json": "./src/data/freedom-park.json",
	"./greenspaces.json": "./src/data/greenspaces.json",
	"./historic-fourth-ward.json": "./src/data/historic-fourth-ward.json",
	"./lullwater-creek.json": "./src/data/lullwater-creek.json",
	"./morningside-nature-preserve.json": "./src/data/morningside-nature-preserve.json",
	"./murphey-candler.json": "./src/data/murphey-candler.json",
	"./oakland-cemetery.json": "./src/data/oakland-cemetery.json",
	"./orme-park.json": "./src/data/orme-park.json",
	"./parkway-angier.json": "./src/data/parkway-angier.json",
	"./parkway-wabash.json": "./src/data/parkway-wabash.json",
	"./piedmont-park.json": "./src/data/piedmont-park.json",
	"./renaissance-park.json": "./src/data/renaissance-park.json",
	"./selena-butler.json": "./src/data/selena-butler.json",
	"./sweetwater.json": "./src/data/sweetwater.json",
	"./tech-green.json": "./src/data/tech-green.json",
	"./template.json": "./src/data/template.json",
	"./winn-park.json": "./src/data/winn-park.json"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/data recursive ^\\.\\/.*\\.json$";


//////////////////
// WEBPACK FOOTER
// ./src/data ^\.\/.*\.json$
// module id = ./src/data recursive ^\.\/.*\.json$
// module chunks = main